<div class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[56px] pb-[40px] bg-[#f8fafdff] w-[100%] relative">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-['archivo'] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch overflow-visible">
      <div *ngIf="errorMessage" class="text-red-600 font-['archivo'] text-[18px]">
        {{ errorMessage }}
      </div>

      <div *ngIf="!errorMessage" class="status-filter-row flex flex-row w-full justify-between items-center gap-4 mb-6">
        <div class="sc-nav-row">
          <button
            type="button"
            class="sc-back-btn"
            aria-label="Back to Senior Center"
            (click)="onBackClick()"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M10 3L5 8L10 13"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Back
          </button>

          <div
            class="sc-segment-control"
            role="radiogroup"
            aria-label="Senior Center application views"
          >
            <button
              *ngIf="canAccessApplicationsTab"
              type="button"
              role="radio"
              class="sc-segment"
              [class.sc-segment--active]="activeTab === 'applications'"
              [attr.aria-checked]="activeTab === 'applications'"
              (click)="setActiveTab('applications')"
            >
              <span class="sc-segment__icon" aria-hidden="true"></span>
              <span class="sc-segment__label">Applications</span>
            </button>
            <button
              *ngIf="canAccessApplicationsTab"
              type="button"
              role="radio"
              class="sc-segment"
              [class.sc-segment--active]="activeTab === 'expiring'"
              [attr.aria-checked]="activeTab === 'expiring'"
              (click)="setActiveTab('expiring')"
            >
              <span class="sc-segment__icon" aria-hidden="true"></span>
              <span class="sc-segment__label">Expiring</span>
              <span
                *ngIf="dueRenewalCount > 0"
                class="sc-segment__count"
                [class.sc-segment__count--alert]="expiredCount > 0"
                aria-hidden="true"
              >{{ dueRenewalCount }}</span>
            </button>
            <button
              *ngIf="canAccessTransportationTab"
              type="button"
              role="radio"
              class="sc-segment"
              [class.sc-segment--active]="activeTab === 'transportation'"
              [attr.aria-checked]="activeTab === 'transportation'"
              (click)="setActiveTab('transportation')"
            >
              <span class="sc-segment__icon" aria-hidden="true"></span>
              <span class="sc-segment__label">Transportation</span>
            </button>
          </div>
        </div>

        <div class="status-filter-actions flex flex-row items-center gap-4">
          <div class="sc-global-search relative">
            <input
              type="text"
              class="sc-global-search__input"
              [ngModel]="searchText"
              (ngModelChange)="onSearchInput($event)"
              [attr.aria-label]="activeTab === 'transportation' ? 'Search transportation requests' : activeTab === 'expiring' ? 'Search expiring applications' : 'Search applications'"
              [placeholder]="searchPlaceholder"
              autocomplete="off"
            />
            <button
              *ngIf="searchText.trim()"
              type="button"
              class="sc-global-search__clear"
              aria-label="Clear search"
              (click)="clearSearch()"
            >
              ×
            </button>
          </div>

          <div #statusFilterContainer class="status-filter">
          <button
            type="button"
            class="status-filter-trigger"
            [class.status-filter-trigger--open]="isStatusMenuOpen"
            [attr.aria-label]="activeTab === 'transportation' ? 'Filter transportation requests by status' : activeTab === 'expiring' ? 'Filter by expiry status' : 'Filter applications by status'"
            [attr.aria-expanded]="isStatusMenuOpen"
            (click)="toggleStatusMenu($event)"
          >
            <span class="status-filter-value">{{ selectedStatusLabel }}</span>
            <svg
              class="status-filter-chevron"
              [class.status-filter-chevron--open]="isStatusMenuOpen"
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1.5L7 6.5L13 1.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <div *ngIf="isStatusMenuOpen" class="status-filter-menu" (click)="$event.stopPropagation()">
            <button
              *ngFor="let statusConfig of statusConfigs"
              type="button"
              class="status-filter-option"
              [class.status-filter-option--active]="selectedStatus === statusConfig.key"
              (click)="onStatusChange(statusConfig.key)"
            >
              {{ statusConfig.label }}
            </button>
          </div>
        </div>

        <div #downloadMenuContainer class="download-filter">
          <button
            type="button"
            class="download-button"
            aria-label="Download approved applications"
            [disabled]="isExporting"
            [attr.aria-expanded]="isDownloadMenuOpen"
            (click)="toggleDownloadMenu($event)"
          >
            <NiIcon icon="download" iconClass="download-icon" />
            <span>{{ isExporting ? 'Exporting...' : 'Download' }}</span>
            <svg
              class="download-chevron"
              [class.download-chevron--open]="isDownloadMenuOpen"
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1.5L7 6.5L13 1.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <div *ngIf="isDownloadMenuOpen" class="download-menu" (click)="$event.stopPropagation()">
            <button
              *ngFor="let option of downloadOptions"
              type="button"
              class="download-option"
              (click)="onDownloadOptionSelected(option.key)"
            >
              {{ option.label }}
            </button>
          </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!errorMessage && expiryBannerMessage && activeTab !== 'expiring'"
        class="sc-expiry-banner"
        role="status"
      >
        <span class="sc-expiry-banner__text">{{ expiryBannerMessage }}</span>
        <button
          *ngIf="canAccessApplicationsTab"
          type="button"
          class="sc-expiry-banner__action"
          (click)="setActiveTab('expiring')"
        >
          View Expiring
        </button>
      </div>

      <div
        *ngIf="!errorMessage && activeTab === 'expiring'"
        class="sc-expiry-banner sc-expiry-banner--on-tab"
        role="status"
      >
        <span class="sc-expiry-banner__text">
          Approved applications expire one year after approval. Staff should start a renewal before the expiry date.
        </span>
      </div>

      <div *ngIf="!errorMessage && displayedApplications.length === 0" class="text-center text-gray-500 py-8 font-['archivo'] text-[18px] w-full">
        {{ tableEmptyMessage }}
      </div>

      <div *ngIf="!errorMessage && displayedApplications.length > 0" class="applications-table w-full">
        <NiTable
          [columns]="columns"
          [data]="displayedApplications"
          trackByKey="applicationId"
          [pagination]="true"
          [pageSize]="10"
          [emptyMessage]="tableEmptyMessage"
        >
          <ng-template niTableCell="expiryStatus" let-row="row">
            <span [class]="expiryBadgeClass(row)">{{ formatExpiryStatusLabel(row) }}</span>
          </ng-template>
          <ng-template niTableCell="actions" let-row="row">
            <button
              *ngIf="activeTab === 'applications' && canContinueApplication(row)"
              type="button"
              class="view-application-btn"
              (click)="onContinueDraftApplication(row.applicationId, row.status)"
            >
              Continue Application
            </button>
            <button
              *ngIf="(activeTab === 'applications' || activeTab === 'expiring') && !canContinueApplication(row)"
              type="button"
              class="view-application-btn"
              (click)="onViewApplication(row.applicationId)"
            >
              View Application
            </button>
            <button
              *ngIf="activeTab === 'expiring' && canContinueApplication(row)"
              type="button"
              class="view-application-btn"
              (click)="onContinueDraftApplication(row.applicationId, row.status)"
            >
              Continue Application
            </button>

            <div *ngIf="activeTab === 'transportation'" class="transportation-actions">
              <button
                type="button"
                class="view-application-btn"
                (click)="onViewTransportationApplication(row.applicationId)"
              >
                View Application
              </button>
              <ng-container *ngIf="canReviewTransportation(row)">
                <button
                  type="button"
                  class="transportation-approve-btn"
                  [disabled]="isReviewing"
                  (click)="onApproveTransportation(row)"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M3 8.2L6.2 11.4L13 4.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Approve
                </button>
                <button
                  type="button"
                  class="transportation-reject-btn"
                  [disabled]="isReviewing"
                  (click)="onRejectTransportation(row)"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  </svg>
                  Reject
                </button>
              </ng-container>
              <button
                *ngIf="canRevokeTransportation(row)"
                type="button"
                class="transportation-revoke-btn"
                [disabled]="isReviewing"
                (click)="onRevokeTransportation(row)"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M3.5 8H12.5M3.5 8L6.5 5M3.5 8L6.5 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Revoke
              </button>
            </div>
          </ng-template>
        </NiTable>
      </div>
    </div>
  </ng-container>
</div>

<NiFormModal
  [isOpen]="isDownloadModalOpen"
  [showCancelIcon]="true"
  [hasBackdrop]="true"
  [preventBackdropClose]="isExporting"
  [className]="'download-modal-panel w-[95vw] max-w-[600px] sm:w-[600px] sm:max-w-[700px] md:w-[700px] max-h-[90vh] sm:max-h-[85vh] min-h-[50vh] sm:min-h-[400px] md:min-h-[480px] mx-2 sm:mx-0 flex flex-col overflow-hidden'"
  (onClose)="closeDownloadModal()"
>
  <div class="download-modal-content">
    <div class="download-modal-header">
      <h2 class="download-modal-title">{{ downloadModalTitle }}</h2>
      <p class="download-modal-subtitle">Select an approval date range.</p>
    </div>

    <div class="download-modal-body">
      <div class="download-modal-section">
        <label class="download-modal-label">Approval Date</label>
        <div class="download-modal-date-fields">
          <NiDatePicker
            class="download-modal-date-picker"
            [label]="''"
            [placeholder]="'From date'"
            [date]="modalDateFrom"
            [clearable]="true"
            leadingIcon="Calendar"
            leadingIconClass="download-modal-date-icon"
            containerStyle="background-color: #ffffff; border: 1px solid #d0d1d4; border-radius: 12px; height: 58px;"
            inputStyle="font-family: Archivo, sans-serif; font-size: 20px; font-weight: 500; color: #111215; width: 100%;"
            (dateChange)="onModalDateFromChange($event)"
          />
          <NiDatePicker
            class="download-modal-date-picker"
            [label]="''"
            [placeholder]="'To date'"
            [date]="modalDateTo"
            [clearable]="true"
            leadingIcon="Calendar"
            leadingIconClass="download-modal-date-icon"
            containerStyle="background-color: #ffffff; border: 1px solid #d0d1d4; border-radius: 12px; height: 58px;"
            inputStyle="font-family: Archivo, sans-serif; font-size: 20px; font-weight: 500; color: #111215; width: 100%;"
            (dateChange)="onModalDateToChange($event)"
          />
        </div>
      </div>

      <div *ngIf="modalExportError" class="download-modal-error">
        {{ modalExportError }}
      </div>
    </div>

    <div class="download-modal-footer">
      <NiFormButton
        label="Cancel"
        variant="outlined"
        color="secondary"
        [fontWeight]="700"
        [fontSize]="18"
        paddingSize="px24_py18"
        styleClass="download-modal-cancel-btn"
        [disabled]="isExporting"
        (onClick)="closeDownloadModal()"
      />
      <NiFormButton
        [label]="isExporting ? 'Exporting...' : 'Export'"
        variant="contained"
        color="primary"
        [fontWeight]="700"
        [fontSize]="18"
        paddingSize="px24_py18"
        styleClass="download-modal-export-btn"
        [disabled]="!canConfirmExport"
        (onClick)="onExportConfirm()"
      />
    </div>
  </div>
</NiFormModal>

<NiFormModal
  [isOpen]="showTransportApproveModal"
  [showCancelIcon]="true"
  [hasBackdrop]="true"
  [preventBackdropClose]="isReviewing"
  [className]="'download-modal-panel w-[95vw] max-w-[560px] mx-2 sm:mx-0 flex flex-col overflow-hidden'"
  (onClose)="onCloseTransportApproveModal()"
>
  <div class="download-modal-content">
    <div class="download-modal-header">
      <h2 class="download-modal-title">{{ transportModalTitle }}</h2>
      <p class="download-modal-subtitle">
        {{ transportModalSubtitle }}
      </p>

      <div class="transport-distance-box" [class.transport-distance-box--warn]="isBeyondAaaMiles">
        <div class="transport-distance-label">Distance to center</div>
        <div class="transport-distance-value">{{ distanceDisplayLabel }}</div>
        <p *ngIf="isBeyondAaaMiles && !isBeyondMetroMiles" class="transport-distance-msg">
          Beyond 3.5 miles — AAA Transportation is not eligible. Metro Transportation may still apply (≤ 7.5 miles).
        </p>
        <p *ngIf="isBeyondMetroMiles" class="transport-distance-msg">
          Beyond 7.5 miles — neither AAA nor Metro qualify under standard rules. Use override only if policy allows, or set Transportation to Not Required.
        </p>
      </div>

      <label
        class="mt-4 block font-['archivo'] text-[16px] font-semibold text-[#111215]"
        for="transport-approve-option"
      >
        Transportation
      </label>
      <select
        id="transport-approve-option"
        class="mt-2 w-full rounded-[12px] border border-[#D0D5DD] bg-white px-[14px] py-[12px] font-['archivo'] text-[16px] text-[#111215]"
        [value]="reviewTransportationOption"
        [disabled]="isReviewing"
        (change)="onReviewTransportationOptionChange($event)"
      >
        <option *ngFor="let opt of transportModalOptionChoices" [value]="opt.value">
          {{ opt.label }}
        </option>
      </select>

      <ng-container *ngIf="requiresFundingTypes">
        <div class="mt-4 block font-['archivo'] text-[16px] font-semibold text-[#111215]">
          Funding type
        </div>
        <p class="mt-1 font-['archivo'] text-[14px] text-[#667085]">
          AAA ≤ 3.5 miles · Metro ≤ 7.5 miles · both allowed when AAA-eligible
        </p>
        <div class="transport-funding-list">
          <label
            *ngFor="let opt of fundingTypeChoices"
            class="transport-funding-item"
            [class.transport-funding-item--disabled]="!isFundingTypeEligible(opt.value) && !reviewFundingOverride"
          >
            <input
              type="checkbox"
              [checked]="isFundingTypeSelected(opt.value)"
              [disabled]="isReviewing || (!isFundingTypeEligible(opt.value) && !reviewFundingOverride)"
              (change)="onToggleFundingType(opt.value, $any($event.target).checked)"
            />
            <span>{{ opt.label }}</span>
            <span
              *ngIf="!isFundingTypeEligible(opt.value) && !reviewFundingOverride"
              class="transport-funding-hint"
            >
              Not eligible for this distance
            </span>
          </label>
        </div>
        <label class="transport-override">
          <input
            type="checkbox"
            [checked]="reviewFundingOverride"
            [disabled]="isReviewing"
            (change)="onToggleFundingOverride($any($event.target).checked)"
          />
          <span>Allow override if applicant does not qualify under standard mile rules</span>
        </label>
      </ng-container>

      <p *ngIf="reviewError" class="text-red-600 font-['archivo'] text-[16px] mt-3">{{ reviewError }}</p>
    </div>
    <div class="download-modal-footer">
      <NiFormButton
        label="Cancel"
        variant="outlined"
        color="secondary"
        [fontWeight]="700"
        [fontSize]="18"
        paddingSize="px24_py18"
        [disabled]="isReviewing"
        (onClick)="onCloseTransportApproveModal()"
      />
      <NiFormButton
        [label]="transportModalConfirmLabel"
        variant="contained"
        color="primary"
        [fontWeight]="700"
        [fontSize]="18"
        paddingSize="px24_py18"
        [disabled]="isReviewing || isLoadingDistance"
        (onClick)="confirmApproveTransportation()"
      />
    </div>
  </div>
</NiFormModal>

<app-staff-reject-modal
  [isOpen]="showRejectModal"
  action="reject"
  [comment]="rejectComment"
  [isSubmitting]="isReviewing"
  [errorMessage]="reviewError"
  (commentChange)="onRejectCommentChange($event)"
  (onConfirmClick)="confirmRejectTransportation()"
  (onCancelClick)="onCloseRejectModal()"
></app-staff-reject-modal>
